module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="control-group">\n    <div id="reviewers-select"></div>\n    <button type="button" class="btn btn-primary btn-xs save">Save</button>\n    <button type="button" class="btn btn-primary btn-xs cancel">Cancel</button>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/review/reviewers-items-select.html
// module id = 406
// module chunks = 0